import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NetworkState {
  isOnline: boolean;
  showChatBotOnLogin: boolean;
  chatBotMode: "floating" | "popup";
}

const initialState: NetworkState = {
  isOnline: navigator.onLine,
  showChatBotOnLogin: false,
  chatBotMode: "floating",
};

const networkObserver = createSlice({
  name: "network",
  initialState,
  reducers: {
    setOnlineStatus(state, action: PayloadAction<boolean>) {
      state.isOnline = action.payload;
    },
    setShowChatBotOnLogin(state, action: PayloadAction<boolean>) {
      state.showChatBotOnLogin = action.payload;
    },
    setChatBotMode(state, action: PayloadAction<"floating" | "popup">) {
      state.chatBotMode = action.payload;
    },
  },
});

export const { setOnlineStatus, setShowChatBotOnLogin, setChatBotMode } =
  networkObserver.actions;
export default networkObserver.reducer;
